import React from "react";
import { RelatedObjectItem } from "./RelatedObjectItem";
import { observer, inject } from "mobx-react";
import { StoreContext } from "../../contexts/StoreContext";

@inject("previewStore")
@observer
export class RelatedObjects extends React.Component {
  static contextType = StoreContext;
  render() {
    const {
      navigationLookupResult,
      setCurrentPage,
      setPerPage,
      setSearchExpression,
      fetchEntityDetails,
    } = this.props;

    const typesToShow =
      navigationLookupResult && navigationLookupResult.navigationLookupBuckets
        ? Object.keys(navigationLookupResult.navigationLookupBuckets).filter(
            (type) => {
              const rootType = navigationLookupResult.params.type;
              if (
                [
                  "Variable",
                  "Member",
                  "Subdomain",
                  "VariableSet",
                  "Combination",
                ].indexOf(rootType) > -1
              ) {
                return type !== "Cubes" && type !== "Frameworks";
                // } else if (["Domain","Subdomain"].indexOf(rootType) > -1) {
                //     return type !== "FacetEnumerations";
              } else {
                return true;
              }
            }
          )
        : [];

    // remove types for which customized views exist
    let typesToShowWithoutCustomView = typesToShow;
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "VariableSet"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("Variables");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "CubeLink"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("CSI Link");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Primary Variables");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Foreign Variables");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Primary Domains");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Foreign Domains");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Primary Cubes");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Foreign Cubes");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Primary Frameworks");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Foreign Frameworks");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "Subdomain"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("Members");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("FacetEnumerations");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "Domain"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("FacetEnumerations");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "MemberHierarchy"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("Member Hierarchies");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Member Hierarchy Nodes");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }

    if (
      navigationLookupResult &&
      (navigationLookupResult.params.type === "Variable" ||
        navigationLookupResult.params.type === "Member")
    ) {
      let index = typesToShowWithoutCustomView.indexOf("Frameworks");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Cubes");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("FacetEnumerations");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf(
        "Semantic TransformationRule"
      );
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "Framework"
    ) {
      let index;
      index = typesToShowWithoutCustomView.indexOf("Data Models");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Primary Variables");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "Variable"
    ) {
      let index = typesToShowWithoutCustomView.indexOf("Members");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
      index = typesToShowWithoutCustomView.indexOf("Member Hierarchies");
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }
    if (
      navigationLookupResult &&
      navigationLookupResult.params.type === "Cube"
    ) {
      let index = typesToShowWithoutCustomView.indexOf(
        "Semantic TransformationRule"
      );
      if (index > -1) {
        typesToShowWithoutCustomView.splice(index, 1);
      }
    }

    if (!typesToShowWithoutCustomView.length) {
      return null;
    }
    return (
      <div ref={this.props.innerRef} className="related-objects custom-panel">
        {this.props.object.type !== "Framework" && (
          <div className="custom-panel-heading">
            <h4>Related</h4>
          </div>
        )}
        <div className="custom-panel-body related-types-list">
          {typesToShowWithoutCustomView.map((type, key) => {
            return (
              <RelatedObjectItem
                bucket={navigationLookupResult.navigationLookupBuckets[type]}
                key={key}
                setCurrentPage={setCurrentPage}
                setPerPage={setPerPage}
                setSearchExpression={setSearchExpression}
                fetchEntityDetails={() =>
                  fetchEntityDetails(undefined, undefined, type)
                }
                type={type}
                typeView={this.props.object.type}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
